import type {
  Direction,
  LogicalAlignment,
  PhysicalAlignment,
  WithInherit,
} from './types';

export const physicalToLogicalAlignmentLTRMap: Record<
  PhysicalAlignment,
  LogicalAlignment
> = {
  left: 'start',
  center: 'center',
  right: 'end',
};

const physicalToLogicalAlignmentRTLMap: Record<
  PhysicalAlignment,
  LogicalAlignment
> = {
  right: 'start',
  center: 'center',
  left: 'end',
};

export const convertPhysicalAlignmentToLogical = (
  physicalAlignment: PhysicalAlignment,
  direction: Direction = 'ltr',
): LogicalAlignment =>
  direction === 'rtl'
    ? physicalToLogicalAlignmentRTLMap[physicalAlignment]
    : physicalToLogicalAlignmentLTRMap[physicalAlignment];

type IValue = Direction | LogicalAlignment;

export const castToInheritIfNeeded = <V extends IValue>(
  value: V,
  parentValue?: V,
): WithInherit<V> => (value === parentValue ? 'inherit' : value);

export const castFromInheritIfNeeded = <V extends IValue>(
  value: WithInherit<V> | undefined,
  parentValue: V,
): V => (!value || value === 'inherit' ? parentValue : value);

export const resolveInheritanceChain = <V extends IValue>(
  valueHierarchy: Array<WithInherit<V> | undefined>,
  ultimateParentValue: V,
): V => {
  for (const currentValue of valueHierarchy) {
    if (currentValue && currentValue !== 'inherit') {
      return currentValue as V; // We've checked it's not 'inherit', so it must be V
    }
  }
  return ultimateParentValue;
};

export const getOppositeAlign = (align: LogicalAlignment) =>
  align === 'start' ? 'end' : 'start';
